// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"208a1f81","453":"6632d2dd","732":"7a66a991"}[chunkId] + ".chunk.js";
};